import { useTitle } from 'my-core/hooks';

import Footer from 'my-components/Footer';

import TermsAndConditionsContent from './TermsAndConditionsContent';

import Typography from '@mui/material/Typography';

export default function TermsAndConditionsPage() {
  useTitle('Terms and Conditions');

  return (
    <>
      <div
        css={({ constants, spacing }) => ({
          maxWidth: 960,
          margin: `${spacing(constants.APPBAR_HEIGHT_UNITS + 4)} auto ${spacing(2)}`,
          padding: spacing(0, 2),
        })}
      >
        <Typography gutterBottom variant="h4">
          Website Terms Of Use
        </Typography>
        <TermsAndConditionsContent />
      </div>
      <Footer />
    </>
  );
}
